<template>
  <v-container fluid>
    <v-slide-y-transition>  
        <v-layout row align-center wrap class="boards">
             <v-progress-circular
                v-if="creating"
                :size="50"
                color="primary"
                indeterminate
                ></v-progress-circular>
                <v-flex v-if="!loading" sm3 v-for="board in boards" :key="board._id" pa-2>
                  <v-card>
                    <v-img
                      class="white--text align-end"
                      height="200px"
                      :src="board.background"
                    ></v-img>
                    <v-card-title primary-title>
                      <div class="headline">{{board.name}}</div>
                    </v-card-title>
                    <v-card-actions class="board-card">
                      <v-btn :to="{ name: 'board', params: {id: board._id}}"
                        color="primary"
                        
                      >
                        View
                      </v-btn>
                       <v-btn class="delete" icon @click="removeBoard($event,{_id: board._id})"
                      
                        
                      >
                        <i class="far fa-trash-alt"></i>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex sm3 pa-2>
                  <v-card class="create-board">

                    <v-card-title>
                      <div class="headline">Create Board</div>
                    </v-card-title>
                    <v-form
                      @submit.prevent="createBoard"
                      v-model="valid"
                      @keydown.prevent.enter
                      v-if="!creating">
                        <v-text-field
                          v-model="board.name"
                          label="Name"
                          :rules="notEmptyRules"
                          type="text"
                          required
                        />
                        <v-text-field class="boardUrlInput"
                          v-model="board.background"
                          label="Background Url"
                          
                          type="text"
                        />
                        <v-btn type="submit" color="primary">Create</v-btn>
                    </v-form>

                   
                  </v-card>
                </v-flex>
        </v-layout>

    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'boards',
  data: () => ({
    valid: false,
    imgUrl: '',
    board: {
      name: '',
      background: '',
    },
    notEmptyRules: [(value) => !!value || ''],
  }),
  mounted(){
    document.querySelector(".v-content__wrap").style.marginTop = "64px";
    this.findBoards({ query: {} })
      .then(response => {
        const boards = response.data || response
      })
  },
  methods:{
    ...mapActions('boards', { findBoards: 'find' } ),
    ...mapActions('boards', { removeBoard: 'remove' } ),
    createBoard() {
      if(this.valid){
        if(this.board.background == ""){
          this.getRandomImg();
        }
        const { Boards } =  this.$FeathersVuex.api;
        const board = new Boards(this.board);
        board.save();
        console.log(board)
        this.board = {
          name: '',
          background: ''
        }
      }
    },
    removeBoard(event, _id) {
     this.$FeathersVuex.api.Boards.store.dispatch('boards/remove',_id);
    },
    getRandomImg(){
       this.imgUrl = 'https://source.unsplash.com/random/1000×600/?nature';
       this.board.background = this.imgUrl;
    }
  },
  computed: {
     ...mapGetters('board', { findBoardInStore: 'find' } ),
     ...mapState('auth', {user: 'payload'}),
    ...mapState('boards', { 
      loading: 'isFindPending' ,
      creating:'isCreatePending'
      } ),
      
    ...mapGetters('boards', { findBoardsInStore: 'find' } ),
    ...mapGetters('board', { removeBoardInStore: 'remove' } ),
    boards () {
      return this.findBoardsInStore(
        { 
        query: {
          ownerId: this.user.user._id
        } 
        }
      ).data;
    },

  }
};
</script>

<style scoped>
.boards .v-card__title {
    padding: 5px 10px;
}
.boards .v-card__title .headline {
    font-size: 18px !important;
}
.boards {
    align-items: start !important;
}
.board-card.v-card__actions {
    display: flex;
    justify-content: space-between;
}
</style>